import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';

@Component({
  selector: 'app-shopping',
  templateUrl: './shopping.page.html',
  styleUrls: ['./shopping.page.scss'],
})
export class ShoppingPage implements OnInit {
  presentView: string;
  showSubCategory: boolean;
  searchValue: string;
  imagesrc: string;
  getReviewPopUp: boolean;
  backValue: string;
  headerValue: string;

  //------------------API VARIAPELS-------------------//
  storeSellertList: any = [];
  sellerReview: any;
  constructor(public router: Router, private services: ServicesProvider) { }

  ngOnInit() {

    this.storeSellertList = [{
      dietcompanyname: "Milk.Kw",
      category:"Baby Needs",
      dietmediaDetails: [
        {
          is_active: 1,
          mediaId: 166,
          media_description: "Diet Production 1",
          media_filename: "https://tomupload.s3.us-east-2.amazonaws.com/MediaUploads/166-1601018696538-production ID_4915346.mp4",
          media_filepath: null,
          media_sortorder: 1,
          media_title: "Diet 1",
          media_type: "Video",
          media_vendor_id: 12,
        },
        {
          is_active: 1,
          mediaId: 166,
          media_description: "Diet Production 1",
          media_filename: "https://tomupload.s3.us-east-2.amazonaws.com/MediaUploads/166-1601018696538-production ID_4915346.mp4",
          media_filepath: null,
          media_sortorder: 1,
          media_title: "Diet 1",
          media_type: "Video",
          media_vendor_id: 12,
        }
      ],
      dietvendorId: 12,
      vendor_address: "Shamiya",
      vendor_filename: "https://tomupload.s3.us-east-2.amazonaws.com/DietDetails/12-1608705947941-A-Basic-Introduction-to-Enterprise-Mobility-Management.jpg",
      vendor_profile_path: "https://tomupload.s3.us-east-2.amazonaws.com/DietDetails/9-1589970778083-1589347163372.jpg",
    },
    {
      dietcompanyname: "Abdullah Fitness Store",
      category:"Fitness",
      dietmediaDetails: [
        {
          is_active: 1,
          mediaId: 166,
          media_description: "Diet Production 1",
          media_filename: "https://tomupload.s3.us-east-2.amazonaws.com/MediaUploads/166-1601018696538-production ID_4915346.mp4",
          media_filepath: null,
          media_sortorder: 1,
          media_title: "Diet 1",
          media_type: "Video",
          media_vendor_id: 12,
        },
        {
          is_active: 1,
          mediaId: 166,
          media_description: "Diet Production 1",
          media_filename: "https://tomupload.s3.us-east-2.amazonaws.com/MediaUploads/166-1601018696538-production ID_4915346.mp4",
          media_filepath: null,
          media_sortorder: 1,
          media_title: "Diet 1",
          media_type: "Video",
          media_vendor_id: 12,
        }
      ],
      dietvendorId: 12,
      vendor_address: "Shamiya",
      vendor_filename: "https://tomupload.s3.us-east-2.amazonaws.com/DietDetails/12-1608705947941-A-Basic-Introduction-to-Enterprise-Mobility-Management.jpg",
      vendor_profile_path: "https://tomupload.s3.us-east-2.amazonaws.com/DietDetails/9-1589970778083-1589347163372.jpg",
    }
  ];

  }



  // -----------\/--------SOME SPECIAL FUNCTION----------\/---------//


  showReviewPopUp() {
    this.getReviewPopUp = !this.getReviewPopUp;
  }
  showSubCat(){
    this.showSubCategory=!this.showSubCategory;
  }
  showSellerReview(openReview){
    this.sellerReview=openReview;
  }
 
  // ------------/\-------SOME SPECIAL FUNCTION-----------/\--------//


  ionViewWillEnter() {
    this.showSubCategory = false;
    this.getReviewPopUp = false;

    switch (localStorage.getItem("NopayGoBack")) {
      case "newEnter": {
        this.showSellerListPage();
        break;
      }
      case "BookingConPage": {
        // this.showCartPage("goFirstPage");
        break;
      }
      default: {
        // this.showShpgFstPage();
      }
    }
  }

  showSellerListPage() {
    this.presentView = "sellerListPage";
    this.backValue="goHome";
  }

  selectProfile(){
    this.presentView="sellerProfilePage";
    this.backValue="goListPage";
  }
  sellerProductsPage(){
    this.presentView="ProductsPage";
    this.backValue="goProfilePage";
  }
  showSellerCat(){
    this.presentView="shoppingCatPage"
    this.backValue="goProductPage";
  }
  showProductInfoPage(){
    this.presentView="productInfoPage";
    this.backValue="goProductPage";
  }
  showCartPage(){
    this.presentView="cartPage";
    this.backValue="goListPage";
  }
  showDeliveryAddress(){
    this.presentView="DeliveryAddPage";
    this.backValue="goCartPage";
  }
  showOrderList(){
    this.presentView="MyOrderPage";
    this.backValue="goListPage"
  }
  showOrderDetails(){
    this.presentView="orderDetailsPage";
    this.backValue="goOredrListPage";
  }
  showTrackOrder(){
    this.presentView="trackOrdersPage";
    this.backValue="goOredrListPage";
  }


  proceedToPay() {
    localStorage.setItem("payBack", "shopping");
    this.router.navigate(['tabs/payment']);
  }
  goBack(value) {
    switch (value) {
      case 'goHome': {
        this.router.navigate(['../tabs/home']);
        break;
      }
      case 'goListPage': {
         this.showSellerListPage();
        break;
      }
      case 'goProfilePage': {
         this.selectProfile();
        break;
      }
      case 'goProductPage': {
         this.sellerProductsPage();
        break;
      }
      case 'goCartPage': {
         this.showCartPage();
        break;
      }
      case 'goOredrListPage': {
         this.showOrderList();
        break;
      }
      case 'goProductInfoPage': {
        // this.viewProductInfo();
        break;
      }
      case 'goSellerPage': {
        // this.showSellersPage();
        break;
      }
      default: {
        // this.showShpgFstPage();
      }
    }
  }
}
